import React, { useState } from "react";
import { Box, Button, Collapse } from "@chakra-ui/react";
import "../style.scss";
import useContainerForm from "../hooks/useContainerForm";
import { ArrowIcon } from "~misc/icons";

const ContainerForm = ({ children, title, isDisabled, accordion = true }) => {
  const { isOpen, toggleAccordion } = useContainerForm();
  return (
    <div className="containerForm container bg-white p-7 rounded-lg mt-[28px] relative">
      {accordion ?
        <div className="flex justify-between py-3" onClick={toggleAccordion}>
          <h2 className="text-2xl font-bold title pb-6">{title}</h2>
          <button
            type="button"
            style={{
              transform: isOpen === false ? "rotate(-90deg)" : "rotate(90deg)",
            }}
          >
            <ArrowIcon />
          </button>
        </div>
        :<></>}
      <Collapse in={isOpen} style={{ overflow: "none" }}>
        <Box p={4} color={""}> {/* color={isDisabled ? "#C6C6C6" : ""} */}
          {children}
        </Box>
      </Collapse>
    </div>
  );
};

export default ContainerForm;
